

export const FIELDTYPE_TEXT:string = 'text';
export const FIELDTYPE_MEDIA:string = 'media';
export const FIELDTYPE_DATETIME:string = 'datetime';
export const FIELDTYPE_NUMBER:string = 'number';
export const FIELDTYPE_BOOLEAN:string = 'boolean';
export const FIELDTYPE_SELECT:string = 'select';

